import React, { type ReactNode } from 'react';
import { AsyncProfileCardNext } from '@atlassian/jira-profilecard-next/src/async';
import type { AccountId } from '@atlassian/jira-shared-types';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller';

type Props = {
	accountId: AccountId;
	children: ReactNode;
};

export const ProfileCard = (props: Props) => (
	<AsyncProfileCardNext
		accountId={props.accountId}
		TenantContextSubscriber={TenantContextSubscriber}
	>
		{props.children}
	</AsyncProfileCardNext>
);
